export default __webpack_public_path__ + "assembly14d41553.png";